import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async connect() {
    if (!this.element.querySelector("pre[data-language]")) return;

    const { highlightCode } = await import("@37signals/lexxy/helpers");
    if (this.element.isConnected) highlightCode();
  }
}
